import React, { FC } from 'react'
import { Grid } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { menuBarList } from './menuTabList'
import { MenuTab } from './MenuTab'

const useStyles = makeStyles(() => ({
  container: {
    maxWidth: 240,
    width: '100%',
    height: '100vh',
    backgroundColor: '#383A40 !important',
    position: 'absolute',
    '& > .MuiGrid-root': {
      margin: '32px 8px',
      backgroundColor: 'transparent',
    },
  },
}))

export const MenuTabs: FC = () => {
  const classes = useStyles()

  return (
    <Grid className={classes.container}>
      <Grid item>
        {menuBarList.map((menuItem) => {
          return <MenuTab item={menuItem} key={menuItem.name} />
        })}
      </Grid>
    </Grid>
  )
}
